import { combineReducers } from 'redux'
import { domainFeatureReducer, domainFeatureSagas } from './Domain'
import { errorPageReducer, errorPageSagas } from './ErrorPage'
import { reducer as listsReducer, sagas as listsSagas } from './Lists'
import type { MarginRateAdjustmentFeatureSlice } from './MarginRateAdjustment/store'
import type { NotificationFeatureSlice } from './Notifications/store'
import { searchReducer, searchSagas } from './Search'

export const featureReducer = combineReducers({
  search: searchReducer,
  lists: listsReducer,
  domain: domainFeatureReducer,
  errorPage: errorPageReducer
})

export type DynamicFeaturesState = NotificationFeatureSlice &
  MarginRateAdjustmentFeatureSlice
export type StaticFeaturesState = ReturnType<typeof featureReducer>

export const featureSagas = [
  ...listsSagas,
  ...searchSagas,
  ...domainFeatureSagas,
  ...errorPageSagas
]
